import React, { useEffect, useState } from "react";
import "./toast.scss";

export default function Toast({
  id,
  message,
  type = "success",
  onClose,
  duration = 4000,
}) {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // 1. Begin the exit animation transition slightly before the duration timer finishes
    const animationTriggerTime = duration - 350;

    const exitAnimationTimer = setTimeout(() => {
      setIsExiting(true);
    }, animationTriggerTime);

    // 2. Safely remove the element completely from the array stack after the animation completes
    const absoluteDismissTimer = setTimeout(() => {
      onClose(id);
    }, duration);

    return () => {
      clearTimeout(exitAnimationTimer);
      clearTimeout(absoluteDismissTimer);
    };
  }, [id, duration, onClose]);

  const handleManualClose = () => {
    setIsExiting(true);
    setTimeout(() => onClose(id), 300);
  };

  return (
    <div
      className={`mini-miles-toast mini-miles-toast--${type} ${
        isExiting ? "mini-miles-toast--exiting" : ""
      }`}
    >
      <div className="toast-content-wrapper">
        <span className="toast-icon-indicator">
          {type === "success" ? "🟢" : "🔴"}
        </span>
        <p className="toast-message-text">{message}</p>
      </div>
      <button
        type="button"
        className="toast-dismiss-btn"
        onClick={handleManualClose}
      >
        ×
      </button>
    </div>
  );
}
